import { render } from "./ReviewDrivingStyle.vue?vue&type=template&id=8d0e6f80"
import script from "./ReviewDrivingStyle.vue?vue&type=script&lang=js"
export * from "./ReviewDrivingStyle.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__